---
title: "Pi Is Now Built into the Entire CLI"
description: "Pi is now built into the Entire CLI, giving users a more direct path to captured sessions, checkpoints, and history."
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. [Pi](http://pi.dev/), an open source coding agent, has been getting a lot of attention lately: more sessions, more real work, and at least one Entire design lead who appears to have adopted it as a coding companion.

![Pi activity by agent line chart](/blog/pi-is-now-built-into-the-entire-cli/activity-by-agent.png)

![Pi contributors top 10 bar chart](/blog/pi-is-now-built-into-the-entire-cli/contributors-top-10.png)

[Pi](https://docs.entire.io/agents/pi) is now built into the [Entire CLI](https://github.com/entireio/cli). Previously, Pi operated as an [external agent plugin](https://github.com/entireio/external-agents/tree/main/agents/entire-agent-pi) that developers could install alongside the CLI. With this release, Pi graduates from plugin to native integration.

<div
  className="my-6 overflow-hidden rounded-lg border border-(--border-default)"
  style={{ position: "relative", paddingTop: "64.51612903225806%" }}
>
  <iframe
    src="https://customer-0x5hsk8lh27fm00g.cloudflarestream.com/89f76783a7be608b7c7c646d8dd9ea1f/iframe?loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-0x5hsk8lh27fm00g.cloudflarestream.com%2F89f76783a7be608b7c7c646d8dd9ea1f%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&startTime=2s"
    title="Enabling Entire with the Pi agent"
    loading="lazy"
    className="absolute top-0 left-0 h-full w-full border-0"
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowFullScreen
  />
</div>

## What It Is

With the new Pi integration, you can install Pi hooks directly from Entire, capture Pi transcripts and tool activity, and keep Pi sessions connected to [checkpoints](https://docs.entire.io/cli/checkpoints), commits, and session history.

Use it when you want to understand a Pi session after the fact, rewind to a known-good checkpoint, or keep the reasoning behind an AI-assisted commit attached to the work itself.

## What It Means for Users

For users, this means less setup and fewer integration steps to manage.

Pi sessions continue to connect to Entire's checkpoint and session history workflow. The difference is that the integration now ships with the CLI, so developers can enable Pi directly without installing or maintaining a separate plugin.

## Try It

In an existing Entire-enabled repository, add Pi as an agent, then start a Pi session.

```shell
entire agent add pi
pi
```

For a new repository, you can enable Entire with Pi in one step.

```shell
entire enable --yes --agent pi
```

## Learn More

Pi support is currently in preview and requires the [Pi CLI](https://pi.dev) to be installed. See the [Pi setup guide](https://docs.entire.io/agents/pi) for more details. Boop.
